"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_shared_js_1 = require("@tableau/api-shared-js");
class AuthoringWorksheetImpl {
    constructor(_registryId) {
        this._registryId = _registryId;
    }
    getAbstractQueryWithDataModel() {
        const service = api_shared_js_1.ApiServiceRegistry.get(this._registryId).getService("EmbeddingVizApiService" /* EmbeddingVizApiService */);
        return service.getEmbeddingAbstractQueryAsync();
    }
    getVizStateWithDataModel() {
        const service = api_shared_js_1.ApiServiceRegistry.get(this._registryId).getService("EmbeddingVizApiService" /* EmbeddingVizApiService */);
        return service.getEmbeddingVizStateWithDataModelAsync();
    }
    setVizStateWithDataModel(vizStateWithDataModel) {
        const service = api_shared_js_1.ApiServiceRegistry.get(this._registryId).getService("EmbeddingVizApiService" /* EmbeddingVizApiService */);
        return service.setEmbeddingVizStateWithDataModelAsync(vizStateWithDataModel);
    }
}
exports.AuthoringWorksheetImpl = AuthoringWorksheetImpl;
//# sourceMappingURL=AuthoringWorksheetImpl.js.map